import { SortOrder } from '../types/SortOrder';

export const myFoldersInitValue = {
  data: {
    currentFolder: undefined,
    foldersCount: 0,
    documentsCount: 0,
    folders: [],
    documents: [],
    sortOrder: 'asc' as SortOrder,
    isLoading: false,
  },
  actions: {
    handleChangePage: () => {},
    handleAddFolder: () => {},
    handleOpenFolder: () => {},
    handleEditFolder: () => {},
    handleDownloadFolder: () => {},
    handleDeleteFolder: () => {},
    handleNavigateToFolder: () => {},
    handleToggleSort: () => {},
  },
};
